import Message from "../../message";
import {useMainStore} from "@/store";

export default class GuildRenamed extends Message
{
    handle()
    {
        useMainStore().RENAME_COMPETITOR({
            id: this.message.guild_id,
            name: this.message.name,
        });
    }
}
